export class Version {
    
   public static version = 'uat2 11052026032410';
    
    public static getUrlVersion(): string {
        return '?version=' + this.getVersion();
    }

    public static getVersion(): string {
        return this.version;
    }
}